// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
  
import Introduction from './components/0-Introduction'
import Enceinte from './components/1-Enceinte'
import Enfants from './components/2-Enfants'
import Couple from './components/3-Couple'
import Conclusion from './components/4-Conclusion'
  
import {TweenMax} from "gsap";
import Datas from './datas.json';
import config from './config';

Vue.config.productionTip = false

Vue.use(VueResource);
Vue.use(VueRouter);

Vue.mixin({
  data () {
    return {
      datas: Datas
    }
  },
  methods: {
    parseJson: function() {
      let nbProduits = this.datas.jeu.produits.produit.length;
      let products = {};
      for(var i=0; i < nbProduits; i++) {
        let produit = this.datas.jeu.produits.produit[i];
        products[produit.nom] = {
          group: produit.groupe,
          category: produit.categorie,
          explication: produit.explication,
          name: produit.bulle
        }
      }
      config.some = products;
    },
    replaceAll: function(str, search, replacement) {
        return str.replace(new RegExp(search, 'g'), replacement);
    },
    changeImgs: function(imgs) {
      /*
      //console.log(imgs);
      // If localhost or my domain, return
      if(window.location.href.indexOf("localhost") != -1 || window.location.origin.includes("sunlimet.com")) return;
      for(var i=0; i < imgs.length; i++) {
        //console.log("-----------");
        let img = imgs[i];
        let src = img.getAttribute("src");
        //console.log(src);
        if(src.indexOf("data:image") != -1 || src.indexOf("www.prioritesantemutualiste.fr") != -1) {
          continue;
        }
        let splitty = src.split("/");
        src = splitty[splitty.length-1];
        src = this.replaceAll(src, "_", "-");
        let extension = src.split(".")[2];
        src = src.split(".")[0] + src.split(".")[1];
        // console.log(src);
        // console.log(extension);
        // let pathSrc = extension == "png" ? "http://www.prioritesantemutualiste.fr/psm/doc/png/" : "http://www.prioritesantemutualiste.fr/psm/doc/jpg/";
        let pathSrc = "static/img/";
        img.setAttribute("src", pathSrc + src);
        // console.log(pathSrc + src);
        // console.log(img);
      }
      */
    },
    closePopinMixin: function(isTuto=true) {
      let name = ".popin";
      if(!isTuto) name = ".popinResult";
      let popin = this.$el.querySelector(name);
      TweenLite.to(popin, 0.6, { rotationY:80, alpha:0, ease:Quad.easeOut, onComplete:function() {
        popin.classList.add("hide");
        TweenLite.to(popin, 0, { rotationY:0, alpha:1, ease:Quad.easeOut });
      }}); 
      document.querySelector(".overlay").classList.add("hide");
    },
    openPopinResult: function(id, img, idContainer) {
      let popinResult = document.querySelector(".popinResult").classList.remove("hide");
      document.querySelector(".overlay").classList.remove("hide");
      let product = config.some[id];
      let valueFinal = "";
      switch(Number(product.category)) {
        case 1:
          valueFinal = "incoutournable";
          break;
        case 2:
          valueFinal = "optionnel";
          break;
        case 3:
          valueFinal = "interdit";
          break;
      }
      let popinResultCorrect = document.querySelector(".popinResult-correct");
      //popinResultCorrect.classList = ""; // IE ERROR
      //popinResultCorrect.classList.add("popinResult-correct");
      popinResultCorrect.classList.remove("popinResult-correct--ok");
      popinResultCorrect.classList.remove("popinResult-correct--forbidden");
      popinResultCorrect.classList.remove("popinResult-correct--ko");
      if((idContainer == 1 && product.category == "1") || (idContainer == 0 && product.category == "2")) {
        popinResultCorrect.classList.add("popinResult-correct--ok");
      } else if(product.category == "3") {
        popinResultCorrect.classList.add("popinResult-correct--forbidden");
      } else {
        popinResultCorrect.classList.add("popinResult-correct--ko");
      }
      document.querySelector(".popinResult-title").innerHTML = product.name.toUpperCase() + "<br>" + valueFinal;
      document.querySelector(".popinResult-img").innerHTML = '<img src="' + img + '">';
      let domDescription = document.querySelector(".popinResult-description");
      domDescription.innerHTML = product.explication;
      product.explication.length > 400 ? domDescription.classList.add("popinResult-description--small") : domDescription.classList.remove("popinResult-description--small");
      TweenLite.from(document.querySelector(".popinResult"), 0.6, { rotationY:80, alpha:0, ease:Quad.easeOut });
      return product.category;
    },
    retrieveName: function(id) {
      return config.some[id].name;
    },
    commonIntro: function() {
      document.querySelector(".overlay").classList.remove("hide");
      document.querySelector(".buttonPrint").classList.remove("hide");
      document.querySelector(".buttonChange").classList.remove("hide");
      document.querySelector(".popin").classList.remove("hide");

      // INTRO
      TweenLite.from(document.querySelector(".popin"), 0.6, { rotationY:80, alpha:0, ease:Quad.easeOut });
      TweenMax.to(document.querySelector(".popin-element1"), 1, {
        left: '200px',
        top: '210px',
        yoyo: true,
        scale: 0.6,
        repeat: -1,
        repeatDelay: 5,
        delay: 1,
        alpha: 0.8,
        ease:Quad.easeOut
      });
      TweenMax.to(document.querySelector(".popin-element2"), 1, {
        left: '530px',
        top: '290px',
        yoyo: true,
        scale: 0.6,
        repeat: -1,
        repeatDelay: 5,
        delay: 1.5,
        alpha: 0.8,
        ease:Quad.easeOut
      });
    } 
  }
})

const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes: [
    { path: "/", component: Introduction },
    { path: "/enceinte", component: Enceinte },
    { path: "/enfants", component: Enfants },
    { path: "/couple", component: Couple },
    { path: "/conclusion", component: Conclusion },
  ]
});

new Vue({
  el: '#app',
  router, 
  template: '<App/>',
  components: { App }
}).$mount("#app")


// WEBPACK FOOTER //
// ./src/main.js